
import { useMutation, useQuery } from "react-query"
import { useToast } from "../../hook/usetoast";
import DataService from '../../config/DataServices'
import { queryClient } from "../../config";

const { postRequest,getRequest} = DataService()






export const useGetProfile = () => {

    return useQuery({
        queryKey: ["get-profile"],
        queryFn: () => {
            return getRequest(`user/get-profile`)
        },
        enabled: !!sessionStorage.getItem('user_JWT'), // Only run query if JWT exists

    })
}
export const useGetMyToken = () => {

    return useQuery({
        queryKey: ["get-myToken"],
        queryFn: () => {
            return getRequest(`user/myToken`)
        }
    })
}

export const useUpdateProfile = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/profile", data)
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
            queryClient.refetchQueries("get-profile");

            return toast.success(success?.message)
        }
    })
}

export const useChangePassword = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/change-password", {...data})
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
            return toast.success(success?.message)
        }
    })
}


export const useGetUserTFA = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/tfa", {...data})
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
      
        }
    })
}

export const useEnableDiableTFA = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/mutate-tfa", {...data})
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
            queryClient.refetchQueries("get-profile");

            return toast.success(success?.message)
        }
    })
}

export const useUploadProfileImg = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: (data) => {
            return postRequest("user/update-img", data)
        },
        onSuccess: success => {
            if (!success?.status) {
                return toast.error(success?.message)
            }
            queryClient.refetchQueries("get-profile");
            return toast.success(success?.message)
        }
    })
}



export const useGethowtobuy = () => {
    return useQuery({
        queryKey: ["howtobuy"],
        queryFn: () => {
            return getRequest("user/howtobuy")
        }
    })
}